import { FC, ReactNode } from 'react';
import withApollo from 'next-with-apollo';
import { v4 as uuidv4 } from 'uuid';
import { NextPage } from 'next';
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  makeVar,
  HttpLink,
  NormalizedCacheObject,
} from '@apollo/client';
import { UserSignupFormValues, ChurchSignupFormValues } from './signup/types';
import { setContext } from '@apollo/client/link/context';

interface Props {
  Page: NextPage;
  props: {
    apollo: ApolloClient<InMemoryCache>;
    children: ReactNode;
  };
}

export const clientCachedSubscriber = makeVar<UserSignupFormValues | undefined>(undefined);
export const clientCachedOrganization = makeVar<ChurchSignupFormValues | undefined>(undefined);

const ApolloWrapper: FC<Props> = ({ Page, props }) => {
  return (
    <ApolloProvider client={props.apollo}>
      <Page {...props} />
    </ApolloProvider>
  );
};

const authLink = setContext((_, { headers }) => {
  const token = sessionStorage.getItem('accessToken');
  const applicationDomain = sessionStorage.getItem('applicationDomain');
  return {
    headers: {
      ...headers,
      'Request-Id': uuidv4(),
      Authorization: token ? `Bearer ${token}` : '',
      'Application-Domain': applicationDomain,
    },
  };
});

export const initializeApollo = (): ApolloClient<NormalizedCacheObject> => {
  return new ApolloClient({
    name: 'chop-marketing-client',
    cache: new InMemoryCache(),
    link: authLink.concat(
      new HttpLink({
        uri: `${process.env.NEXT_PUBLIC_GATEWAY_HOST ?? 'http://online-dev.church:7777'}/graphql`,
        credentials: 'include',
      })
    ),
  });
};

export default withApollo(
  () => {
    return initializeApollo();
  },
  {
    render: ApolloWrapper,
  }
);
